import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store"
import {saver} from '@gigauser/common/src/network/saver'



const initialState = {
    value: saver 
}

export const saverSlice = createSlice({
    name: "saver", 
    initialState, 
    reducers: {
        setSaver: (state, action: PayloadAction<any>) =>{
            state.value = action.payload
        }
    }
})

export const {setSaver} = saverSlice.actions
// Other code such as selectors can use the imported `RootState` type
export const selectSaver = (state: RootState) => state.saver.value
export default saverSlice.reducer
